/**
 * @generated SignedSource<<7a500e89fa62586dfa2074007d93c01a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttachPaymentMethodInput = {
  customerAccountIdentifier: string;
  paymentMethodType: string;
  paymentServiceType: string;
  paymentTerms?: string | null | undefined;
};
export type SetUpOnAccountPaymentMethodDialogMutation$variables = {
  input: AttachPaymentMethodInput;
};
export type SetUpOnAccountPaymentMethodDialogMutation$data = {
  readonly attachPaymentMethod: {
    readonly paymentMethods: ReadonlyArray<{
      readonly id: string;
      readonly paymentMethodType: string;
      readonly paymentTerms: string | null | undefined;
    }>;
  };
};
export type SetUpOnAccountPaymentMethodDialogMutation = {
  response: SetUpOnAccountPaymentMethodDialogMutation$data;
  variables: SetUpOnAccountPaymentMethodDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PaymentMethod",
  "kind": "LinkedField",
  "name": "paymentMethods",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentTerms",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetUpOnAccountPaymentMethodDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAccount",
        "kind": "LinkedField",
        "name": "attachPaymentMethod",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetUpOnAccountPaymentMethodDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAccount",
        "kind": "LinkedField",
        "name": "attachPaymentMethod",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47176cf6141266626eac946dcac3e7f3",
    "id": null,
    "metadata": {},
    "name": "SetUpOnAccountPaymentMethodDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SetUpOnAccountPaymentMethodDialogMutation(\n  $input: AttachPaymentMethodInput!\n) {\n  attachPaymentMethod(input: $input) {\n    paymentMethods {\n      id\n      paymentMethodType\n      paymentTerms\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3e9ecdbca2aafce9d5a4964a63a403d";

export default node;
